
import { motion } from "framer-motion";

const StrategiesIntro = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }} 
      className="mb-12"
    >
      <div className="bg-white rounded-xl shadow-lg border border-[#D3DCE4] p-8 mb-12 transform hover:shadow-xl transition-all duration-300">
        <div className="flex items-center justify-center mb-6">
          <img 
            src="/lovable-uploads/ef16abbc-a16c-49f6-9ae4-1a512b1d779b.png" 
            alt="METRADE Premium" 
            className="h-10 object-contain" 
          />
        </div>
        <h1 className="text-3xl font-bold text-corporate-primary-100 mb-6 text-center">
          What is METRADE Premium
        </h1>
        <p className="text-corporate-neutral-75 leading-relaxed text-lg max-w-3xl mx-auto text-center">
          This new gold icon represents the Premium strategies offered by Metrade. Whenever you see this seal, it means our qualified team of experts has thoroughly vetted the trading setup—from historical performance and risk management to the provider's credibility. This icon symbolizes trust, quality, and transparency, assuring traders that the strategy meets our rigorous standards.
        </p>
      </div>
    </motion.div>
  );
};

export default StrategiesIntro;
